import { useState } from 'react';
import { Settings as SettingsIcon, Users, Briefcase, Layers, KeyRound, ChevronRight } from 'lucide-react';

import { useAuth } from '../auth/AuthContext.jsx';
import { DropdownsPanel }    from '../components/settings/DropdownsPanel.jsx';
import { UsersPanel }        from '../components/settings/UsersPanel.jsx';
import { StartupsPanel }     from '../components/settings/StartupsPanel.jsx';
import { SectorGroupsPanel } from '../components/settings/SectorGroupsPanel.jsx';
import { ApiTokensPanel }   from '../components/settings/ApiTokensPanel.jsx';

import './SettingsView.css';

const TABS = [
    { id: 'dropdowns',     label: 'Dropdowns',     Icon: SettingsIcon,
      description: 'Manage the picker options used across the CRM.',
      visibleTo: ['admin', 'team'] },
    { id: 'sector_groups', label: 'Sector groups', Icon: Layers,
      description: 'Tell the matchmaker which sectors should be treated as related.',
      visibleTo: ['admin', 'team'] },
    { id: 'users',         label: 'Users',         Icon: Users,
      description: 'Invite teammates or give clients read-only access to their pipeline.',
      visibleTo: ['admin'] },
    { id: 'portfolio',     label: 'Portfolio',     Icon: Briefcase,
      description: 'Portfolio companies, their profile, and outreach email templates.',
      visibleTo: ['admin', 'team', 'client'] },  // clients see only their own
    { id: 'api_tokens',    label: 'API tokens',    Icon: KeyRound,
      description: 'Personal access tokens for Claude Code, n8n and other tools.',
      visibleTo: ['admin', 'team', 'client'] },  // everyone manages their own
];

export function SettingsView() {
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState('dropdowns');

    const visibleTabs = TABS.filter(t => t.visibleTo.includes(user?.role || ''));
    const active = visibleTabs.find(t => t.id === activeTab) || visibleTabs[0];

    return (
        <div className="settings">
            <header className="settings-topbar">
                <div>
                    <h1 className="display settings-title">Settings</h1>
                    <p className="settings-subtitle">
                        {active?.description || 'Manage the CRM.'}
                    </p>
                </div>
            </header>

            <div className="settings-body">
                <aside className="settings-nav">
                    {visibleTabs.map(({ id, label, Icon }) => (
                        <button
                            key={id}
                            className={`settings-nav-item${active.id === id ? ' is-active' : ''}`}
                            onClick={() => setActiveTab(id)}
                        >
                            <Icon size={15} strokeWidth={1.75} />
                            <span>{label}</span>
                            <ChevronRight size={14} strokeWidth={1.5} className="settings-nav-chev" />
                        </button>
                    ))}
                </aside>

                <main className="settings-content">
                    {active.id === 'dropdowns'     && <DropdownsPanel />}
                    {active.id === 'sector_groups' && <SectorGroupsPanel />}
                    {active.id === 'users'         && <UsersPanel />}
                    {active.id === 'portfolio'     && <StartupsPanel />}
                    {active.id === 'api_tokens'    && <ApiTokensPanel />}
                </main>
            </div>
        </div>
    );
}
